export { MagazinePromotedArticleAuthorAvatar, type MagazinePromotedArticleAuthorAvatarProps } from './MagazinePromotedArticleAuthorAvatar';
export { MagazinePromotedArticleContent, type MagazinePromotedArticleContentProps } from './MagazinePromotedArticleContent';
export { MagazinePromotedCarousel, type MagazinePromotedCarouselProps } from './MagazinePromotedCarousel';
